import { Action } from '@ngrx/store';
import { GuidanceAndAdvice } from 'src/app/model/ngrx/guidance-and-advice.model';
export const ADD_GUIDANCE_AND_ADVICE = '[GUIDANCEANDADVICE] Add';
export const REMOVE_GUIDANCE_AND_ADVICE = '[GUIDANCEANDADVICE] Remove';
// AddPersonalDetails
export class AddGuidanceAndAdvice implements Action {
    readonly type = ADD_GUIDANCE_AND_ADVICE;
    constructor(public payload: GuidanceAndAdvice) {}
}
// RemovePersonalDetails
export class RemoveGuidanceAndAdvice implements Action {
    readonly type = REMOVE_GUIDANCE_AND_ADVICE;
    constructor(public payload: number) { }
}
export type Actions = AddGuidanceAndAdvice | RemoveGuidanceAndAdvice;